module.exports = __webpack_public_path__ + "img/11.26044b08.png";